module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/other_service_two-2a9a2d8b94ce62ffed6a8f6f6c43c0b9.png";